import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "players-table" }
const _hoisted_2 = { class: "players-table-alltime" }
const _hoisted_3 = { class: "players-table-subtitle" }
const _hoisted_4 = {
  key: 0,
  class: "players-table-empty"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-account-outline" }, "0", -1)
const _hoisted_6 = { class: "players-table-item-name" }
const _hoisted_7 = {
  key: 0,
  class: "mdi mdi-trophy"
}
const _hoisted_8 = {
  key: 1,
  class: "mdi mdi-medal"
}
const _hoisted_9 = { class: "players-table-item-points" }
const _hoisted_10 = { class: "players-table-lastlevel" }
const _hoisted_11 = { class: "players-table-subtitle" }
const _hoisted_12 = {
  key: 0,
  class: "players-table-empty"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "mdi mdi-account-outline" }, "0", -1)
const _hoisted_14 = { class: "players-table-item-name" }
const _hoisted_15 = {
  key: 0,
  class: "mdi mdi-trophy"
}
const _hoisted_16 = {
  key: 1,
  class: "mdi mdi-medal"
}
const _hoisted_17 = { class: "players-table-item-points" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('playersTableAllTime')), 1),
      (_ctx.allTime.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noPlayersInTable')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTime, (player, place) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "players-table-item",
          key: player.name
        }, [
          _createElementVNode("div", _hoisted_6, [
            (place == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7))
              : _createCommentVNode("", true),
            (place == 1 || place == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(player.name), 1)
          ]),
          _createElementVNode("div", _hoisted_9, _toDisplayString(player.points), 1)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('playersTableLastLevel')), 1),
      (_ctx.allTime.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('noPlayersInTable')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lastLevel, (player, place) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "players-table-item",
          key: player.name
        }, [
          _createElementVNode("div", _hoisted_14, [
            (place == 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
              : _createCommentVNode("", true),
            (place == 1 || place == 2)
              ? (_openBlock(), _createElementBlock("span", _hoisted_16))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(player.name), 1)
          ]),
          _createElementVNode("div", _hoisted_17, _toDisplayString(player.points), 1)
        ]))
      }), 128))
    ])
  ]))
}